export default "__VITE_ASSET__efI88kUA__"